var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 26.5H17.5V4.5H29C29.1667 3.33333 28.5 0.8 24.5 0H11.5V26.5Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H9V4.5H0C0 3.33333 0.6 0.8 3 0Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26H9V21.5H0C0 22.6667 0.6 25.2 3 26Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26H20V21.5H29C29 22.6667 28.4 25.2 26 26Z",
    fill: "#E1E1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5H9V11.5H0V6.5Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5H29V11.5H20V6.5Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5H9V18.5H0V13.5Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5H29V18.5H20V13.5Z",
    fill: "#E1E1E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.c84e78516ea2acc7fa0373212a388630.svg";
export { ForwardRef as ReactComponent };